import React, { use } from 'react';
import { SubjectProfileDetailsTagsCard } from './cards';
import {
    SubjectProfileDetailsPersonalInformationCard,
    SubjectProfileDetailsSiteInformationCard,
    SubjectProfileDetailsSubjectStatusCard,
    SubjectProfileDetailsTreatmentStatusCard,
} from './cards/details';
import SubjectProfileDetailsReviewCard from './cards/subject-profile-details-review-card';
import styles from './index.module.scss';
import { SMActiveReviewContext } from '@pages-clean/subject-monitoring/components/monitoring-toolkit/active-review-tab/context';

type Props = {
    canEdit: boolean;
    studyRef: string;
    datasetId: number;
    datasetCreatedDate: Date;
    subjectId: number;
    subjectCode: string;
    subjectNumber: string;
};

const SubjectProfileSideContent = ({
    canEdit,
    studyRef,
    datasetId,
    datasetCreatedDate,
    subjectId,
    subjectCode,
    subjectNumber,
}: Props) => {
    const smActiveReviewContext = use(SMActiveReviewContext);

    return (
        <div className={styles.sideContentBody}>
            {/* TODO: conditionally show this card only if the review "SubjectLevelReview" field (which doesn't exist yet) is true */}
            {smActiveReviewContext?.state.reviewRecordId != null && (
                <SubjectProfileDetailsReviewCard
                    canEdit={canEdit}
                    studyRef={studyRef}
                    datasetId={datasetId}
                    subjectId={subjectId}
                    subjectNumber={subjectNumber}
                    reviewRecordId={smActiveReviewContext.state.reviewRecordId}
                    sessionId={smActiveReviewContext.state.sessionId}
                />
            )}

            <SubjectProfileDetailsPersonalInformationCard
                studyRef={studyRef}
                datasetId={datasetId}
                subjectId={subjectId}
            />

            <SubjectProfileDetailsTagsCard
                canEdit={canEdit}
                studyRef={studyRef}
                datasetId={datasetId}
                subjectCode={subjectCode}
            />

            <SubjectProfileDetailsSubjectStatusCard
                studyRef={studyRef}
                datasetId={datasetId}
                datasetCreatedDate={datasetCreatedDate}
                subjectId={subjectId}
            />

            <SubjectProfileDetailsTreatmentStatusCard studyRef={studyRef} datasetId={datasetId} subjectId={subjectId} />

            <SubjectProfileDetailsSiteInformationCard studyRef={studyRef} datasetId={datasetId} subjectId={subjectId} />
        </div>
    );
};

export default SubjectProfileSideContent;
